import { OfferModel } from '../../../offer/model/OfferModel';
import { OfferState } from '../../../offer/model/OfferState';

export const sortOffers = () => {
    return (offerA: OfferModel, offerB: OfferModel) => {
        if (offerA.state === OfferState.ENQUIRY_DECLINED && offerB.state !== OfferState.ENQUIRY_DECLINED) {
            return 1;
        }
        if (offerA.state !== OfferState.ENQUIRY_DECLINED && offerB.state === OfferState.ENQUIRY_DECLINED) {
            return -1;
        }
        if (offerA.state === OfferState.ENQUIRY_DECLINED && offerB.state === OfferState.ENQUIRY_DECLINED) {
            return 0;
        }

        if (!offerA.hasValidProducts() && offerB.hasValidProducts()) {
            return 1;
        }
        if (offerA.hasValidProducts() && !offerB.hasValidProducts()) {
            return -1;
        }
        if (!offerA.hasValidProducts() && !offerB.hasValidProducts()) {
            return 0;
        }

        const offerAIsDefaultSupplier = offerA.supplierId === offerA.vessel?.defaultSupplierId;
        const offerBIsDefaultSupplier = offerB.supplierId === offerB.vessel?.defaultSupplierId;

        if (offerAIsDefaultSupplier && !offerBIsDefaultSupplier) {
            return -1;
        }
        if (!offerAIsDefaultSupplier && offerBIsDefaultSupplier) {
            return 1;
        }

        if (offerA.ppl && offerB.ppl) {
            return offerA.ppl.value - offerB.ppl.value;
        }

        return 0;
    };
};
